module.exports = __webpack_public_path__ + "img/SKMJ_saferoad7.e82c472f.jpg";